<template>
  <div class="sign" ref="sign">
    <div class="sign-content">
      <v-header v-show="false"></v-header>
      <span class="title" v-show="false">{{$t('login.title')}}</span>
      <div class="login_header">
      	<img v-if="lang=='zh'"  src="../../../static/img/login2/login_header.png" alt="">
      	<img v-if="lang=='en'"  src="../../../static/img/login2/login_headeren.png" alt="">
      	<img v-if="lang=='ja'" src="../../../static/img/login2/login_headerja.png" alt="">
      </div>
      <el-main class="sign-msg">
        <div class="pos_icon">
          <el-input
            :placeholder="$t('login.enteraccount')"
            v-model="username"
            maxlength="32"
            clearable
            class="loginusername"
            @change="loginphone"
          ></el-input>
          <div class="user_pic">
            <img src="../../image/people.png" alt=" ">
          </div>
        </div>
        <p class="denger" v-show="flag1">{{$t('login.accountnot')}}</p>
        <p class="denger" v-show="flag2">{{$t('login.accountLength')}}</p>
        <div class="pos_icon">
          <div class="user_psw"><img src="../../image/password.png" alt=" "></div>
          <el-input
            :placeholder="$t('login.accountpassword')"
            :type="showPsw"
            v-model="password"
            maxlength="16"
            class="loginpassword"
            autocomplete="off"
          ></el-input>
          <div class="eye" @click="eye('showPsw')"><img src="../../../static/img/login2/registeremail3.png" alt=""></div>
        </div>
        <p class="denger" style="top:42%;" v-show="flag3">{{$t('login.passwordLength')}}</p>
        <!-- 验证码 -->
        <div class="ver">
          <el-input
            :placeholder="$t('login.entercode')"
            v-model="code"
            v-show="flag"
            clearable
            class="Verification"
          ></el-input>
          <img v-show="flag" :src="img" class="image" @click="change" ref="banner">
        </div>
        <!-- <br /> -->
        <div class="for-btn" style="max-width: 720px;">
          <div><router-link to="/forgetpassword">{{$t('login.forgetPsd')}}?</router-link></div>
          <div>|</div>
          <div><router-link to="/register">{{$t('loginswiper.goregister')}}</router-link></div>
        </div>
        <!-- <br /> -->
        <div class="btn">
          <el-button class="login" type="primary" @click="login">{{$t('login.signIn')}}</el-button>
        </div>
        <div class="privacy">
          {{$t('login.agree')}}<router-link to="/privacyStatement">{{$t('login.privacyStatement')}}</router-link>
        </div>
      </el-main>
      <div class="footer" v-if="false">
        <p class="three">{{$t('login.ThirdPartyLogin')}}</p>
        <ul>
          <li>
            <a
              href="https://graph.qq.com/oauth2.0/authorize?response_type=code&client_id=101523560&redirect_uri=http://dognesstest.dognessnetwork.com/authentication/social/callback/qq&state=dogness"
            >
              <img src="@/image/qq.png">
            </a>
          </li>
          <li>
            <a
              href="https://api.weibo.com/oauth2/authorize?client_id=1981994093&redirect_uri=http://dognesstest.dognessnetwork.com/authentication/social/callback/weibo&response_type=code"
            >
              <img src="@/image/sina.png">
            </a>
          </li>
          <li>
            <a @click="facebooklogin">
              <img src="@/image/facebook.png">
            </a>
          </li>
          <li>
            <a @click="twitch">
              <img src="@/image/twitter.png">
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import {
  systemInit,
  userLogin,
  getimg,
  email,
  registerSendEmail
} from "../../api/index.js";
import { Devicestate } from "../../deviceApi/index.js";
import store from "../../store/store.js";
import Qs from "qs";
import axios from "axios";
import footernav from "../../components/footernav";
import header from "../../components/header";
export default {
  name: "login",
  data() {
    return {
      username: "",
      password: "",
      code: "",
      count: 0,
      checked: false,
      flag: false,
      flag1: false,
      flag2: false,
      flag3: false,
      img: "",
      num: 1,
      loginsuccess: false,
      loginshowflag: true,
      lang: localStorage.getItem("locale"),
      showPsw:'password'
    };
  },
  watch: {
    //提示限制输入账户和密码的长度
    username(newvulue) {
      if (newvulue.length == 32) {
        // this.flag2=true;
        this.$message({
          message: this.$t("login.accountLength"),
          type: "warning"
        });
      }
    },
    password(newpassword) {
      if (newpassword.length == 16) {
        // this.flag3=true;
        this.$message({
          message: this.$t("login.passwordLength"),
          type: "warning"
        });
      }
    }
  },
  created() {
    //判断浏览器语言
    // var JsSrc = (
    //     navigator.language || navigator.browserLanguage
    // ).toLowerCase();

    // if (JsSrc.indexOf("zh") >= 0) {
    //     // 假如浏览器语言是中文
    // } else if (JsSrc.indexOf("en") >= 0) {
    //     // 假如浏览器语言是英文
    // } else {
    //     // 假如浏览器语言是其它语言
    // }
    systemInit()
      .then(res => {
        let data = res.data.data;
        // if (data == sessionStorage.token) {
        //     this.$router.push({ path: "/" });
        //     this.$message({
        //         type: "success",
        //         message: "已登录，请勿重复登录"
        //     });
        // } else {
        if (data != undefined) {
          this.$store.commit("set_token", data); //根据store中set_token方法将token保存至localStorage/sessionStorage中，data["Authentication-Token"]，获取token的value值
        }
        // }
      })
      .catch(error => {
        console.log(error);
      });
  },
  mounted() {
    //生命周期
    // console.log(sessionStorage.token);
    if (sessionStorage.getItem("imgcode")) {
      this.flag = true;
      getimg()
        .then(res => {
          this.img = "data:image/jpeg;base64," + res.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
    if (localStorage.getItem("username") && localStorage.getItem("password")) {
      this.username = localStorage.getItem("username");
      this.password = localStorage.getItem("password");
      this.checked = true;
    } else {
      this.checked = false;
    }
  },
  components: {
    "v-foot": footernav,
    "v-header": header
  },
  methods: {
    eye(type){
      switch (type){
        case 'showPsw':
        if(this.showPsw=='password'){
          this.showPsw =  'text'
        }else{
          this.showPsw =  'password'
        }
        break;
      }
    },
    loginphone() {
      var params = Qs.stringify({
        account: this.username
      });
      email(params)//验证账号是否存在
        .then(res => {
//           console.log("email:", res);
          if (res.data.data == false) {
            this.flag1 = true;
          } else {
            this.flag1 = false;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    login() {
    	let code = this.GetQueryString("deviceCode");
    	if(code==''||code==undefined){
    		this.$alert("<p>" + this.$t("prompt.QrnoCode") + "</p>", {
					confirmButtonText: this.$t("prompt.sure"),
					dangerouslyUseHTMLString: true
					});
				return false;
    	}
      if (this.username.length > 0 && this.password.length > 0) {
        var params = Qs.stringify({
          username: this.username,
          password: this.password,
          imageCode: this.code,
          isWeb: true
        });
        userLogin(params)
          .then(res => {
            // console.log("afterlogin:", res);
            if (res.data.header.status == 1000) {
            	sessionStorage.setItem("login", "1");
              localStorage.setItem("token", res.data.data.x_auth_token);
              localStorage.setItem("codeId", code);
              this.$store.commit("set_token", res.data.data.x_auth_token);
              if (this.checked == true) {
                localStorage.setItem("username", this.username);
                localStorage.setItem("password", this.password);
              } else {
                localStorage.removeItem("username");
                localStorage.removeItem("password");
              }
              sessionStorage.removeItem("imgcode");
              this.loginsuccess = true;
           
           		this.Devicestate(code);
           
           
           
              // this.$router.push({
              //     path: "/mynewsedit"
              // });
            } else
            //  if (res.data.header.status == 3026) {
            //   //未激活的邮箱再次发送激活邮件并跳转到激活页面
            //   var params = Qs.stringify({
            //     email: this.username,
            //     password: this.password,
            //     lang: ""
            //   });
            //   registerSendEmail(params)
            //     .then(res => {
            //       // console.log("重发：", res);
            //       if (res.data.header.status == 1000) {
            //         this.$message({
            //           message: this.$t("prompt.noactivationemail"),
            //           center: true,
            //           type: "warning"
            //         });
            //       }
            //     })
            //     .catch(error => {
            //       console.log(error);
            //     });
            // } else
             if (res.data.header.status == 3000) {
              this.$message({
                message: this.$t("prompt.messageerror"),
                center: true,
                type: "error"
              });
            } else {
              this.$message({
                message: this.$t("prompt.messageerror"),
                center: true,
                type: "error"
              });
              if (res.data.data.hasImgCode) {
                sessionStorage.setItem("imgcode", res.data.data.hasImgCode);
              }
              if (res.data.header.status == 3001) {
                this.flag = true;
                getimg()
                  .then(res => {
                    this.img = "data:image/jpeg;base64," + res.data.data;
                  })
                  .catch(error => {
                    console.log(error);
                  });
              }
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        this.$message({
          message: this.$t('login.noAccOrPsd'),
          center: true,
          type: "error"
        });
      }
    },
    //获取url参数=========
  	GetQueryString(name){
		     var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
		     var r = window.location.search.substr(1).match(reg);
		     if(r!=null)return  unescape(r[2]); return null;
		},
		//获取设备详情
		Devicestate(code){
				var params = Qs.stringify({
	        deviceCode: code
	      });
			 	Devicestate(params)
			 .then(res => {
         if (res.data.header.status == 1000) {
         		if(res.data.data==1){
         				console.log('设备可以绑定')
         			  this.$router.push({
	                name: "activation",
	                query: {
	                  accessToken: localStorage.token,
	                  deviceCode: code
	                }
              	});
         		}else{
         				console.log('设备已经绑定')
         			 this.$router.push({
	                name: "showInformation",
	                query: {
	                  accessToken: localStorage.token,
	                  deviceCode: code
	                }
	              });       
         		}
         }
        })
        .catch(error => {
          console.log(error);
        });
		},
    change() {
      getimg()
        .then(res => {
          this.img = "data:image/jpeg;base64," + res.data.data;
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>
<style>
.el-message {
  min-width: 85%;
}
.loginusername.el-input--suffix .el-input__inner,
.loginpassword.el-input--suffix .el-input__inner {
  padding-left: 2.8rem;
}
.loginusername .el-input__inner,
.loginpassword .el-input__inner {
  height: 2.6rem;
  line-height: 2.6rem;
  border-radius: 0;
}
.loginusername input,.loginpassword input{
  border: 0;
  border-bottom: 1px solid#cccccc;
  padding-left: 2.8rem;
}
</style>
<style scoped>
.pos_icon{
  position: relative;
}
.eye{
		position: absolute;
		right: 0.5rem;
		top: 0.5rem;
	}
	.eye img{
		width: 1.2rem;
	}

.set a {
  display: block;
  width: 100%;
}

.login_header {
  width: 100%;
  text-align: center;
  margin: 0 auto;
}
.login_header img {
  width: 100%;
  vertical-align: middle;
}
.title {
  text-align: center;
  font-size: 0.8rem;
  display: block;
  color: #828282;
  padding-top: 5px;
  /* padding:10px 0; */
}
.logo {
  width: 8rem;
}
/*.sign-header {
    text-align: center;
    background-color: #0ca8e3;
    color: white;
    font-family: "微软雅黑";
    font-size: 18px;
}
.sign-header p {
    padding-top: 15px;
    font-weight: bold;
}*/
.el-input {
  /*margin-top: 10px;*/
  margin-bottom: 20px;
}
.check {
  margin-top: 10px;
}
.forget {
  position: absolute;
  right: 15px;
}
.for-btn {
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  color: #cccccc;
}
.for-btn a{
  color: #cccccc;
  font-size: 0.8rem;
}
.forget a {
  color: #0f589b;
}
.btn {
  font-size: 1rem;
  height: 2.6rem;
  width: 72%;
  margin: 0 auto;
  margin-top: 30px;
}
.el-button--primary {
  width: 100%;
  border-radius: 1.3rem;
  background-image: linear-gradient(to right , #65d3e8, #7dc3f2);
  border: 0;
}
.privacy{
  width: 90%;
  margin: 0 auto;
  text-align: right;
  font-size: 0.6rem;
  color: #65d3e8;
  letter-spacing: 2px;
  margin-top: 10px;
}
.privacy a{
  color: #f17f10;
  border-bottom: 1px solid#f17f10;
}

.sign-msg {
  position: relative;
}
.user_pic,
.user_psw {
  position: absolute;
  z-index: 5;
  font-size: 0;
  padding-right: 10px; 
  border-right: 2px solid #cccccc;
}
.user_pic img,
.user_psw img {
  width: 1.2rem;
  margin-left: 0.5rem;
}
.user_pic img{
  width: 1rem;
  margin-left: 0.7rem;
}
.user_pic,.user_psw {
  top: 10%;
}
.el-input--suffix .el-input__inner {
  padding-left: 2.2rem !important;
}
.set a {
  color: white;
}
.Verification {
  width: 50%;
}
.denger {
  position: absolute;
  top: 21%;
  width: 80%;
  margin: 0 auto;
  font-size: 0.625rem;
  color: red;
  margin-top: 5px;
}

/*第三方登陆*/
/*.three {
    text-align: center;
    color: #708090;
    position: relative;
}
.three:after {
    content: "";
    border-bottom: solid 1px #dcdcdc;
    width: 35%;
    display: block;
    position: absolute;
    top: 50%;
    right: 0;
}
.three:before {
    content: "";
    border-bottom: solid 1px #dcdcdc;
    width: 35%;
    display: block;
    position: absolute;
    top: 50%;
    left: 0;
}
.footer ul {
    display: flex;
    margin-top: 50px;
}
.footer ul li {
    flex: 1;
    position: relative;
}
.footer ul li img {
    width: 50px;
    height: 50px;
    position: absolute;
    left: 50%;
    transform: translate(-50%);
}
.footer ul li p {
    font-size: 15px;
    text-align: center;
    margin-top: 50px;
    color: black;
}
.ver {
    position: relative;
}
.image {
    position: absolute;
    right: 0%;
    top: 70%;
    transform: translate(0%, -70%);
}*/
/*第三方登陆*/
.three {
  text-align: center;
  color: #b4b4b4;
  position: relative;
  font-size: 0.8rem;
  margin-top: 2rem;
}
.three:after {
  content: "";
  border-bottom: solid 1px #b4b4b4;
  width: 35%;
  display: block;
  position: absolute;
  top: 50%;
  right: 0;
}
.three:before {
  content: "";
  border-bottom: solid 1px #b4b4b4;
  width: 35%;
  display: block;
  position: absolute;
  top: 50%;
  left: 0;
}
.footer ul {
  display: flex;
  margin-top: 1rem;
}
.footer ul li {
  flex: 1;
  position: relative;
}
.footer ul li img {
  width: 2rem;
  height: 2rem;
  position: absolute;
  left: 50%;
  transform: translate(-50%);
}
.footer ul li p {
  font-size: 0.8rem;
  text-align: center;
  margin-top: 2.5rem;
  color: black;
}
.ver {
  position: relative;
}
.image {
  position: absolute;
  right: 0%;
  top: 70%;
  transform: translate(0%, -70%);
}
</style>


// WEBPACK FOOTER //
// src/m_page/login/login.vue